import React, { forwardRef } from "react";
import cx from "clsx"
import classesResponsive from "../../../Shared/scss/Responsive.module.scss"
import ServiceBox from "./ServiceBox";
import styles from "./scss/SecondSection.module.scss"
import SectionTitle from "../../../Shared/SectionTitle";

const SecondSection = forwardRef((_props, ref) => {
  return (
    <div className={cx(styles.secondSection, classesResponsive.paddingLeftRight )} ref={ref}>
      <SectionTitle>Serviciile Noastre</SectionTitle>
      <div className={styles.servicesContainer}>
      <ServiceBox
        name="Igienizare Profesionala"
        image="/images/services/igienizare.png"
        description="lorem ipsum lorem ipsumlorem ipsumlorem ipsumlorem ipsumlorem ipsumlorem ipsumlorem ipsumlorem ipsumlorem ipsum"
      />
      <ServiceBox
        name="Tratament Paradontoza"
        image="/images/services/paradontoza.jpg"
        description="lorem ipsum lorem ipsumlorem ipsumlorem ipsumlorem ipsumlorem ipsumlorem ipsumlorem ipsumlorem ipsumlorem ipsum"
      />
      <ServiceBox
        name="Implanturi Dentare"
        image="/images/services/implant.jpg"
        description="lorem ipsum lorem ipsumlorem ipsumlorem ipsumlorem ipsumlorem ipsumlorem ipsumlorem ipsumlorem ipsumlorem ipsum"
      />
      <ServiceBox
        name="Tratament Carii"
        image="/images/services/igienizare.png"
        description="lorem ipsum lorem ipsumlorem ipsumlorem ipsumlorem ipsumlorem ipsumlorem ipsumlorem ipsumlorem ipsumlorem ipsum"
      />
      </div>
    </div>
  );
});

export default SecondSection;
